import 'css-chunksrc/client/pages/zonesPage/projectsPage/zone/loader/styles.scss';export default {
  "loader": "_loader_349he_1",
  "header": "_header_349he_6",
  "addZoneButton": "_addZoneButton_349he_15",
  "list": "_list_349he_21",
  "item": "_item_349he_28"
};